import { APPLICATIONS } from "../lib/content";
import SectionHeader from "../components/SectionHeader";
import { GeneratorConcept } from "../components/GeneratorConcept";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ApplicationsPage() {
  return (
    <main data-testid="page-applications">
      <SEO
        path="/applications"
        image="/brand/og-applications.jpg"
        title="Applications"
        description="LogDrive applications across defense (UAS, robotics, manned ground), aerospace (eVTOL, contra-rotating propellers), marine (electric outboards), energy (flywheel storage) and robotics actuators."
      />
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <SectionHeader
            kicker="/ applications"
            title={<>Five domains.<br />One reducer architecture.</>}
            lead="The Logarithmic Drive is platform-agnostic. Below are the priority
domains where partners are engaging with us today — defense, aerospace
& eVTOL, marine, energy generation, and humanoid robotics."
          />
        </div>
      </section>

      {APPLICATIONS.map((a, i) => (
        <section
          key={a.slug}
          id={a.slug}
          data-testid={`application-${a.slug}`}
          className={`relative py-24 md:py-32 ${i % 2 === 1 ? "bg-[#0a0a0a] border-y border-white/5" : ""}`}
        >
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center">
            <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <div className="relative aspect-[4/3] overflow-hidden border border-white/10">
                <img src={a.image} alt="" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent" />
                <div className="absolute top-4 left-4 font-mono-tech text-[10px] uppercase tracking-widest text-white/80 bg-black/60 px-2 py-1 border border-white/15">
                  {a.kicker}
                </div>
              </div>
            </div>
            <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
                0{i + 1} / {APPLICATIONS.length}
              </div>
              <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95] mt-4">
                {a.title}
              </h2>
              <p className="mt-6 text-white/70 leading-relaxed text-base md:text-lg max-w-xl">
                {a.blurb}
              </p>
              <ul className="mt-8 space-y-3">
                {a.bullets.map((b) => (
                  <li key={b} className="flex gap-3 text-white/80">
                    <span className="mt-[10px] h-1 w-1 bg-[#FF3B30] inline-block shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                data-testid={`cta-${a.slug}`}
                className="mt-8 inline-flex items-center gap-3 border border-white/20 hover:border-white hover:bg-white/5 text-white font-mono-tech uppercase tracking-widest text-[11px] px-6 py-3"
              >
                Discuss a program in {a.slug} <ArrowUpRight size={14} />
              </Link>
            </div>
          </div>
          {a.slug === "robotics" && (
            <div className="max-w-[1440px] mx-auto px-6 md:px-10">
              <GeneratorConcept />
            </div>
          )}
        </section>
      ))}
    </main>
  );
}
